import {AdmsRepository, AdmsAsset} from './AdmsActions'

//Описание ADMS каталога
const initialVAdmsState = {
    state: "empty",         //Состояние загрузки ADMS каталога
    rfilter: [],            //Обязательный фильтр, который накладывается для отбора элементов, например отбирать только онтологии
    conditions: [],         //Массив условий отбора
    offset: 0,
    limit: 10,
    count: -1,              //Всего количество элементов. -1 данные по количеству не загружены.
    head: {"link": [], "vars": ["IRI", "dsn", "dsv"]},
    distinct: false,
    ordered: true,
    assets: [],
    taxonomy: null,         //Массив элементов вида {IRI: {type: "uri", value: "http://csi.semanticpro.org/authority/asset-category"}}
                            //После загруженного содержимого появится элемент concepts c концептами, schema данными схемы и state - состояние
    stack: null,            //Стек значений vadms
};

export const vadms = (state = { ...initialVAdmsState} , action) => {
    switch (action.type) {
        case AdmsRepository.EMPTY: 
            return{
                ...initialVAdmsState,
                state: "empty"
            }
        case AdmsRepository.SET_RFILTER: 
            return{
                ...state,
                rfilter: action.rfiter,
                state: "empty",
                assets: [],
            }            
        case AdmsRepository.LOAD_STARTED: 
            return{
                ...state,
                state: "load"
            }
        case AdmsRepository.LOAD_ERROR: 
            return {
                ...state,
                state: "error",
                error: action.error
            };
        case AdmsRepository.LOAD_ASSETS: 
            return {
                ...state,
                offset: action.offset, 
                limit: action.limit, 
                count: action.count, 
                head: action.head, 
                distinct: action.distinct, 
                ordered: action.ordered, 
                assets: action.assets,
                state: "loaded",
            };
        case AdmsRepository.LOAD_NEXTASSETS: 
            return {
                ...state,
                offset: action.offset, 
                limit: action.limit, 
                head: action.head, 
                distinct: action.distinct, 
                ordered: action.ordered, 
                assets: [...state.assets, ...action.assets],
                state: "loaded",
            };
        case AdmsRepository.LOAD_THEMETAXONOMY:
            return {
                ...state,
                state: "loaded",
                taxonomy: action.taxonomy,
            };
        case AdmsRepository.LOAD_TAXONOMY:
            const n = (state.taxonomy)?[...state.taxonomy]: [];
            let isExist = false; //Нужно, если элемент отсутствовал
            for (let i=0; i<n.length; i++) {
                if (isExist) break;
                const schema = n[i];
                //Каждый элемент {IRI: {type: "uri", value: "http://csi.semanticpro.org/authority/asset-category"}
                //Label: {type: "literal", xml:lang: "ru", value: "Категория семантического актива"}}
                if ((schema.IRI) && (schema.IRI.value==action.taxonomy)){
                    schema.concepts = action.concepts,
                    schema.schema = action.schema;
                    schema.state="loaded";
                    isExist = true;
                }
            }
            if (!isExist){
                const t = {IRI: {type: "uri", value: action.taxonomy}, concepts: action.concepts, schema: action.schema, state: "loaded"};
                n.push(t);
            }
            return {
                ...state,
                state: "loaded",
                taxonomy: n
            };

        case AdmsRepository.STATISTICS:
            const {statistics} = state;
            const s = (statistics)?statistics:{};
            s[action.IRI] = (typeof s[action.IRI] ==='undefined')? action.statistic: Object.assign({}, s[action.IRI], action.statistic);
            return {
                ...state,
                statistics: s,
            };

        case AdmsRepository.ADD_ASSET:
            const added = (state.assets && Array.isArray(state.assets))?[...state.assets]: [];
            added.push({IRI: {type: "uri", value: action.iri},
                    dsn: {type: "literal", value: action.label},
                    dsv: {type: "typed-literal", datatype: "http://www.w3.org/2001/XMLSchema#decimal", value: ""}
            })
            return {
                ...state,
                assets: added,
                state: "added"
            };
        case AdmsRepository.REMOVE_ASSET:
            const r = (state.assets && Array.isArray(state.assets))?[...state.assets]: [];
            return {
                ...state,
                assets: r.filter(asset => asset.IRI.value!=action.iri),
                state: "remove"
            };            
        case AdmsRepository.CONDITIONS: 
            return{
                ...state,
                assets: [],
                offset: 0,
                statistics: {},
                conditions: action.conditions,
                state: "empty"
            }
        case AdmsRepository.LOAD_DESCRIPTION: 
            const nadesc = (state.assets)?[...state.assets]: [];
            for (let i=0; i<nadesc.length; i++) {
                const nadesc_a = nadesc[i];
                if ((nadesc_a.IRI) && (nadesc_a.IRI.value==action.IRI)){
                    nadesc_a.description = action.description;
                    //Если в отбор попадают с IRI дубликатами, то повторно вызывается загрузка описания
                    //break;
                }
            }
            return{
                ...state,
                assets: nadesc,
            }
        case AdmsRepository.PUSH:
            return {
                ...state,
                stack : {...state}
            }            
        case AdmsRepository.POP:
            const pop = (state.stack)? state.stack: state;
            return {
                ...pop,
            }            
        default:
            return state;
    }
};

//Дефаултные значения для ассета
const initialVAssetState = {
    state: "empty",     //Состояние ассета
    iri: null,
    head: {             //Заголовок полученных данных. См. результаты запроса в request.js для values_sparql
        link:[],        //Неполнятно зачем возвращается TODO выяснить в документации.
        vars:[]         //Переменные, которые определены в данных (по их названию пожно получить занчение)
    },
    predicates: [],     //Список загруженных предикатов
    languages:  [],     //Список доступных языков (языки для которых есть данные)
    values: [],
    distributions: [], //Массив элементов http://www.w3.org/ns/dcat#distribution (распространение содержимого)
};
export const vasset = (state = { ...initialVAssetState}, action) => {
    switch (action.type) {
        case AdmsAsset.EMPTY: 
            return{
                ...initialVAssetState,
            }
        case AdmsAsset.LOAD_STARTED: 
            return{
                ...state,
                state: "load",
            }
        case AdmsAsset.LOAD_ERROR: 
            return {
                ...initialVAssetState,
                state: "error",
                error: action.error
            };
        case AdmsAsset.LOAD_ASSET: 
            return {
                ...state,
                iri: action.iri,
                values: action.values,
                head: action.head, 
                predicates: action.predicates, 
                languages: action.languages,
                distributions: action.distributions,
                wikies: action.wikies,
                state: "loaded",
            };
        case AdmsAsset.LOAD_LABELBYIRI:
            const lbi = (state.values && Array.isArray(state.values))?[...state.values]:[];
            for (let i=0; i<lbi.length; i++) {
                if (lbi[i].object.value == action.iri)
                    lbi[i].labels = {head: action.head, values: action.values};
            }
            return {
            ...state,
            values: lbi,
        };
        case AdmsAsset.LOAD_DISTRIBUTIONS: 
            return {
                ...state,
                distributions: action.distributions
            };
        case AdmsAsset.LOAD_WIKIES: 
            return {
                ...state,
                wikies: action.wikies
            };
        case AdmsAsset.LOAD_DETAIL: 
            const ld = (state.values && Array.isArray(state.values))?[...state.values]:[];
            const {predicat, object } = action.triplet;
            for (let i=0; i<ld.length; i++) {
                if ((ld[i].object.value == object.value) && (ld[i].predicat.value == predicat.value)){
                    ld[i].values = action.values;
                    ld[i].state = action.state;
                    ld[i].head = action.head;
                }
            }
            return {
                ...state,
                values: ld,
            };

        case AdmsAsset.REMOVE_DISTRIBUTION:
            const rd = (state.distributions && Array.isArray(state.distributions))?[...state.distributions]: [];
            return {
                ...state,
                values: state.values.filter(value => value.object.value != action.iri),
                distributions: rd.filter(distribution => distribution.object.value!=action.iri)
            };                        

        case AdmsAsset.REMOVE_WIKI:
            const rw = (state.wikies && Array.isArray(state.wikies))?[...state.wikies]: [];
            return {
                ...state,
                values: state.values.filter(value => value.object.value != action.iri),
                wikies: rw.filter(wiki => wiki.object.value!=action.iri)
            };                        
            
        case AdmsAsset.ADD_DISTRIBUTION:
            const ad = (state.distributions && Array.isArray(state.distributions))?[...state.distributions]: [];
            ad[ad.length] = {predicat: {type: "uri", value: "http://www.w3.org/ns/dcat#distribution"}, object: {type: "uri", value: action.iri}}
            return {
                ...state,
                distributions: ad
            };                                
            
        case AdmsAsset.ADD_WIKI:
            const aw = (state.wikies && Array.isArray(state.wikies))?[...state.wikies]: [];
            aw[aw.length] = {predicat: {type: "uri", value: "http://hbz.ru/ontologies/emd/wiki"}, object: {type: "uri", value: action.iri}}
            return {
                ...state,
                wikies: aw
            };                                
    default:
            return state;
    }
}
